export const colorSchemaList = {
  table: [
    {
      label: "Default",
      value: "category10",
      colors: [],
    },
    {
      label: "Sunset",
      value: "orange",
      colors: ["#FF4500", "#FF450050", "#fff", "#000"],
    },
    {
      label: "Ocean",
      value: "blue",
      colors: ["#1E90FF", "#1E90FF50", "#fff", "#000"],
    },
    {
      label: "Pastel",
      value: "purple",
      colors: ["#9370DB", "#9370DB50", "#fff", "#000"],
    },
    {
      label: "Forest",
      value: "darkgreen",
      colors: ["#228B22", "#228B2250", "#fff", "#000"],
    },
    {
      label: "Fire",
      value: "red",
      colors: ["#B22222", "#B2222250", "#fff", "#000"],
    },
  ],

  others: [
    {
      label: "Default",
      value: "category10",
      colors: [
        "#e81416",
        "#ffa500",
        "#4b369d",
        "#faeb36",
        "#79c314",
        "#487de7",
        "#70369d",
        "#c07800",
        "#d14b4b",
        "#56589b",
      ],
    },
    {
      label: "Corporate",
      value: "nivo",
      colors: [
        "#0E2841",
        "#E8E8E8",
        "#156082",
        "#E97132",
        "#0F9ED5",
        "#196B24",
        "#A02B93",
        "#91A0A5",
        "#274D68",
        "#4A9682",
      ],
    },
    {
      label: "Contemporary",
      value: "accent",
      colors: [
        "#44546a",
        "#e8e8e8",
        "#4472C4",
        "#ED7D31",
        "#A5A5A5",
        "#FFC000",
        "#4472C4",
        "#D2D2D2",
        "#6B8BA4",
        "#B36B31",
      ],
    },
    {
      label: "Heritage",
      value: "dark2",
      colors: [
        "#1F497D",
        "#e8e8e8",
        "#4F81BD",
        "#C0504D",
        "#9BBB59",
        "#8064A2",
        "#4BACC6",
        "#B1B1B1",
        "#3A6B9A",
        "#BD726E",
      ],
    },
    {
      label: "Monochrome",
      value: "paired",
      colors: [
        "#001111",
        "#2B2B2B",
        "#484848",
        "#616161",
        "#7F7F7F",
        "#9D9D9D",
        "#BFBFBF",
        "#D3D3D3",
        "#E8E8E8",
        "#F5F5F5",
      ],
    },
    {
      label: "Warm Blues",
      value: "pastel1",
      colors: [
        "#203864",
        "#4BACC6",
        "#92A8D1",
        "#1Fa97D",
        "#6D9EEB",
        "#6FA8DC",
        "#3C78D8",
        "#5A9BD4",
        "#A2a4F9",
        "#C97AF8",
      ],
    },
    {
      label: "Bright Blues",
      value: "pastel2",
      colors: [
        "#0070C0",
        "#00B0F0",
        "#92D050",
        "#00B0B0",
        "#92D000",
        "#00A800",
        "#008080",
        "#5CB3FF",
        "#4CD4D4",
        "#99FF99",
      ],
    },
    {
      label: "Sky Blues",
      value: "set1",
      colors: [
        "#1F4E79",
        "#4B8DF7",
        "#C5D9F1",
        "#9Ff5E8",
        "#7D97A8",
        "#29a499",
        "#4A7EBB",
        "#6CA0DC",
        "#A9bFF4",
        "#D684F6",
      ],
    },
    {
      label: "Aqua Greens",
      value: "set2",
      colors: [
        "#70AD47",
        "#00B050",
        "#00B0F0",
        "#00B0B0",
        "#00A3A3",
        "#004800",
        "#008080",
        "#40C087",
        "#335CCC",
        "#660FCC",
      ],
    },
    {
      label: "Dark Shades",
      value: "category10Dark",
      colors: [
        "#b21213",
        "#cc8400",
        "#3a2a7a",
        "#c7b32b",
        "#629d10",
        "#3863b3",
        "#582a7a",
        "#991111",
        "#a05e00",
        "#2d225c",
      ],
    },
    {
      label: "Light Shades",
      value: "category10Light",
      colors: [
        "#ff4f50",
        "#ffcc66",
        "#7257c7",
        "#fef080",
        "#b2e285",
        "#7aa3ff",
        "#a472c7",
        "#ff9999",
        "#ffd699",
        "#c2b2ff",
      ],
    },
    {
      label: "Pastel Shades",
      value: "category10Pastel",
      colors: [
        "#ff9999",
        "#ffd1a3",
        "#a594c7",
        "#fff5cc",
        "#c2e7b2",
        "#a3c4ff",
        "#b594c7",
        "#ffe5e5",
        "#cce5ff",
        "#d6f5d6",
      ],
    },
    {
      label: "Muted Shades",
      value: "category10Muted",
      colors: [
        "#c74242",
        "#ffae42",
        "#6b5ea8",
        "#e0e05e",
        "#95d089",
        "#5f85e7",
        "#8b5ea8",
        "#a86442",
        "#b2b25e",
        "#7d99b0",
      ],
    },
    {
      label: "Lush Greens",
      value: "set3",
      colors: [
        "#9BBB59",
        "#92D050",
        "#00B050",
        "#548235",
        "#88C057",
        "#70AD47",
        "#0F7B0F",
        "#A9D18E",
        "#C5D0B3",
        "#DFDAD3",
      ],
    },
    {
      label: "Rosy Reds",
      value: "rosyReds",
      colors: [
        "#ffcccc",
        "#ffb3b3",
        "#ff9999",
        "#ff6666",
        "#ff3333",
        "#ff0000",
        "#cc0000",
        "#990000",
        "#e60000",
        "#cc6666",
      ],
    },
    {
      label: "Sunny Oranges",
      value: "sunnyOranges",
      colors: [
        "#ffe5cc",
        "#ffEEb3",
        "#ffcc99",
        "#ffb266",
        "#ff9933",
        "#ff8000",
        "#cc6600",
        "#994c00",
        "#ffaa33",
        "#cc7a00",
      ],
    },
    {
      label: "Majestic Purples",
      value: "majesticPurples",
      colors: [
        "#e5ccff",
        "#daAAff",
        "#cc88ff",
        "#b266ff",
        "#a644ff",
        "#9933ff",
        "#8000ff",
        "#6600cc",
        "#4c0099",
        "#5900b3",
      ],
    },
    {
      label: "Oceanic Blues",
      value: "oceanicBlues",
      colors: [
        "#cce5ff",
        "#b3dDff",
        "#99ccff",
        "#80bfff",
        "#66b2ff",
        "#3399ff",
        "#007fff",
        "#0066cc",
        "#004c99",
        "#0059b3",
      ],
    },
    {
      label: "Verdant Greens",
      value: "verdantGreens",
      colors: [
        "#ccffcc",
        "#77ff99",
        "#99ff99",
        "#66ff66",
        "#33ff33",
        "#00ff00",
        "#33cc33",
        "#00cc00",
        "#00b300",
        "#009900",
      ],
    },
    {
      label: "Golden Yellows",
      value: "goldenYellows",
      colors: [
        "#fff7cc",
        "#fff4b2",
        "#ffef99",
        "#ffe066",
        "#ffe766",
        "#ffdf33",
        "#ffd700",
        "#e6c200",
        "#ccac00",
        "#997f00",
      ],
    },
    {
      label: "Blushing Roses",
      value: "blushingRoses",
      colors: [
        "#ffe6e6",
        "#ffcccc",
        "#ffb3b3",
        "#ff9999",
        "#ff8080",
        "#ff9999",
        "#e67373",
        "#cc6666",
        "#cc4d4d",
        "#994d4d",
      ],
    },
    {
      label: "Ocean Breeze",
      value: "oceanBreeze",
      colors: [
        "#e0f7fa",
        "#b2ebf2",
        "#80deea",
        "#4dd0e1",
        "#26c6da",
        "#00bcd4",
        "#00acc1",
        "#0097a7",
        "#00838f",
        "#006064",
      ],
    },
  ],
};

export const initialTabSchema = [
  {
    label: "Sunset",
    value: "orange",
    colors: ["#FF4500", "#ef8f28", "#FFFFFF"],
  },
  {
    label: "Forest",
    value: "darkgreen",
    colors: ["#0aad12", "#7ad51d", "#FFFFFF"],
  },
  {
    label: "Ocean",
    value: "blue",
    colors: ["#2046dc", "#01bcd5", "#FFFFFF"],
  },
  {
    label: "Pastel",
    value: "purple",
    colors: ["#b04fd0", "#2c26a7", "#FFFFFF"],
  },
  {
    label: "Fire",
    value: "red",
    colors: ["#B22222", "#B2222250", "#FFFFFF"],
  },
  {
    label: "CelcomDigi",
    value: "celcomdigi",
    colors: ["#0084DD", "#FFDF00", "#001871"],
  },
];

export const tabSchema = initialTabSchema;

export const getCombinedTabSchema = (customPalettes = []) => {
  const rawList = Array.isArray(customPalettes)
    ? customPalettes
    : Array.isArray(customPalettes?.data)
    ? customPalettes.data
    : Array.isArray(customPalettes?.results)
    ? customPalettes.results
    : [];

  // Start with default presets, but if customPalettes has updated colors for any preset, use those updated colors
  const list = initialTabSchema.map((preset) => {
    const override = rawList.find(
      (c) =>
        (c?.value && c.value.toLowerCase() === preset.value.toLowerCase()) ||
        (c?.label && c.label.toLowerCase() === preset.label.toLowerCase())
    );
    if (override && Array.isArray(override.colors) && override.colors.length >= 3) {
      return {
        ...preset,
        ...override,
        colors: override.colors,
        _id: override._id,
      };
    }
    return { ...preset };
  });

  // Add all other custom palettes
  rawList.forEach((item) => {
    if (
      item &&
      item.value &&
      !list.some(
        (p) =>
          p.value.toLowerCase() === item.value.toLowerCase() ||
          p.label.toLowerCase() === item.label?.toLowerCase()
      )
    ) {
      list.push({
        label: item.label,
        value: item.value,
        colors: item.colors || ["#000000", "#000000", "#ffffff"],
        _id: item._id,
        isCustom: true,
      });
    }
  });

  return list;
};

export const findTabPalette = (identifier, customPalettes = []) => {
  if (!identifier) return null;
  const list = getCombinedTabSchema(customPalettes);

  // 1. Exact value match
  let match = list.find((p) => p.value === identifier);
  if (match) return match;

  // 2. Exact _id match
  match = list.find((p) => p._id && String(p._id) === String(identifier));
  if (match) return match;

  // 3. Case-insensitive value or label match
  const clean = String(identifier).toLowerCase().trim();
  match = list.find(
    (p) =>
      p.value?.toLowerCase() === clean ||
      p.label?.toLowerCase() === clean ||
      p.value?.toLowerCase()?.replace(/[^a-z0-9]/g, "") === clean.replace(/[^a-z0-9]/g, "") ||
      p.label?.toLowerCase()?.replace(/[^a-z0-9]/g, "") === clean.replace(/[^a-z0-9]/g, "")
  );
  if (match) return match;

  // 4. Check raw customPalettes list directly
  const rawList = Array.isArray(customPalettes)
    ? customPalettes
    : Array.isArray(customPalettes?.data)
    ? customPalettes.data
    : Array.isArray(customPalettes?.results)
    ? customPalettes.results
    : [];

  match = rawList.find(
    (p) =>
      p?.value === identifier ||
      (p?._id && String(p._id) === String(identifier)) ||
      p?.value?.toLowerCase() === clean ||
      p?.label?.toLowerCase() === clean
  );
  if (match) return match;

  return null;
};

export const getColor = (name, index = 0, customList = []) => {
  // If name is already an array of color strings
  if (Array.isArray(name) && name[index]) {
    return name[index];
  }
  const palette = findTabPalette(name, customList);
  if (palette?.colors?.[index]) {
    return palette.colors[index];
  }
  return initialTabSchema[0]?.colors?.[index] || "#000000";
};
